module.exports = __webpack_public_path__ + "img/check.6e4d2a32.svg";